import { render, staticRenderFns } from "./CButtons_separate.vue?vue&type=template&id=aef33f56&scoped=true"
import script from "./CButtons_separate.vue?vue&type=script&lang=js"
export * from "./CButtons_separate.vue?vue&type=script&lang=js"
import style0 from "./CButtons_separate.vue?vue&type=style&index=0&id=aef33f56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef33f56",
  null
  
)

export default component.exports